import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { MediaMatcher } from '@angular/cdk/layout';
import { Subscription } from 'rxjs';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

import { MenuItems, SidebarSection } from '../../../shared/menu-items/menu-items';
import { AuthService } from '../../../auth/services/auth.service';
import { ProfileService, UserProfile } from '../../../dms/services/profile.service';
import { BrandingService, OrganizationBranding } from '../../../dms/services/branding.service';
import { environment } from '../../../../environments/environment';
// Switched off with Bank Reconciliation / Research Grants (see the constructor).
// import { ReconciliationAlertBadgeService } from '../../../bank-reconciliation/services/reconciliation-alert-badge.service';
// import { GrantAlertBadgeService } from '../../../research-grants/services/grant-alert-badge.service';

@Component({
  selector: 'app-vertical-sidebar',
  templateUrl: './vertical-sidebar.component.html',
  styles: [`
    .user-profile {
        padding: 20px 15px;
        text-align: center;
        background-size: cover !important;
        background-position: center !important;
    }
    .org-logo-wrapper {
        margin-bottom: 10px;
    }
    .org-logo {
        max-width: 120px;
        max-height: 50px;
        object-fit: contain;
    }
    .org-name {
        font-size: 14px;
        font-weight: 500;
        margin-bottom: 15px;
        text-transform: uppercase;
        letter-spacing: 1px;
    }
    .profile-img img {
        width: 70px;
        height: 70px;
        border-radius: 50%;
        object-fit: cover;
        border: 3px solid rgba(255, 255, 255, 0.3);
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    }
    .profile-text a {
        color: #ffffff;
        text-decoration: none;
        display: inline-flex;
        align-items: center;
        font-weight: 500;
        cursor: pointer;
    }
    .profile-text a:hover {
        opacity: 0.9;
    }
    .profile-text a i {
        margin-left: 5px;
        font-size: 10px;
    }

    /* ---- Sidebar nav (plain <a> — no mat-list-item / MDC) ----
       Three visual states, from weakest to strongest:
         hover    -> faint brick tint
         open     -> light brick tint panel + 3px brick bar (section / expanded sub-menu)
         current  -> solid brick fill, white text (the page you are on)       */
    .sidebar-nav {
        padding: 8px 0;
    }
    @keyframes sidebarReveal {
        from { opacity: 0; transform: translateY(-4px); }
        to   { opacity: 1; transform: none; }
    }
    /* Closed sections add no spacing of their own: the header pitch stays the
       same as before the panels existed. Only the open panel grows. */
    .sidebar-section {
        margin: 0 6px;
        padding: 0;
        border-radius: 8px;
        border-left: 3px solid transparent;
        transition: background-color 0.18s ease, border-color 0.18s ease;
    }
    .sidebar-section.is-open {
        background: rgba(156, 67, 55, 0.05);
        border-left-color: #9c4337;
        margin: 4px 6px;
        padding-bottom: 4px;
    }
    .sidebar-section--plain {
        border-left: 0;
        margin-top: 0;
    }
    .sidebar-section__items {
        animation: sidebarReveal 0.18s ease-out;
    }
    .sidebar-link {
        height: 45px;
        padding: 0 15px;
        margin: 0 5px 6px 5px;
        display: flex;
        align-items: center;
        font-size: 15px;
        white-space: nowrap;
        color: #607d8b;
        text-decoration: none;
        cursor: pointer;
        border-radius: 6px;
        transition: background-color 0.15s ease, color 0.15s ease;
    }
    .sidebar-link:hover {
        color: #9c4337;
        background: rgba(156, 67, 55, 0.06);
    }
    .sidebar-link:hover .sidebar-icon {
        color: #9c4337;
    }
    .sidebar-link .sidebar-icon {
        color: #99abb4;
        margin-right: 8px;
        font-size: 24px;
        width: 24px;
        height: 24px;
    }
    .sidebar-link .sidebar-label {
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .sidebar-link .dd-icon {
        font-size: 16px;
        width: 16px;
        height: 16px;
        transition: transform 0.2s ease-in;
        margin-left: 5px;
        color: #99abb4;
    }
    .sidebar-link.selected {
        background: #b8655a;
        border-radius: 4px;
        color: #ffffff;
    }
    .sidebar-link.selected .sidebar-icon,
    .sidebar-link.selected .sidebar-label {
        color: #ffffff;
    }
    .sidebar-link.selected .dd-icon {
        color: #ffffff;
        transform: rotate(-180deg);
    }
    /* Expanded sub-menu parent: tint, not fill. Only the current page is solid. */
    .sidebar-link.sub-parent.selected {
        background: rgba(156, 67, 55, 0.08);
        color: #9c4337;
    }
    .sidebar-link.sub-parent.selected .sidebar-icon,
    .sidebar-link.sub-parent.selected .sidebar-label,
    .sidebar-link.sub-parent.selected .dd-icon {
        color: #9c4337;
    }
    .sidebar-link--danger,
    .sidebar-link--danger .sidebar-icon,
    .sidebar-link--danger:hover,
    .sidebar-link--danger:hover .sidebar-icon {
        color: #d32f2f;
        font-weight: 500;
    }
    /* When active it looks like any other active link (default fill, white text). */
    .sidebar-link--danger.selected,
    .sidebar-link--danger.selected .sidebar-icon,
    .sidebar-link--danger.selected .sidebar-label {
        color: #ffffff;
    }
    .saperator {
        display: flex;
        align-items: center;
        width: 100%;
        border: 0;
        background: transparent;
        font-family: inherit;
        text-align: left;
        cursor: pointer;
        font-size: 12px;
        margin: 6px 0 4px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 1px;
        color: #99abb4;
        white-space: nowrap;
        padding: 8px 15px;
        border-radius: 6px;
        transition: color 0.15s ease;
    }
    .saperator:hover {
        color: #9c4337;
    }
    .sidebar-section.is-open > .saperator {
        color: #9c4337;
        margin-bottom: 2px;
    }
    .saperator .saperator-label {
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .saperator .saperator-caret {
        font-size: 18px;
        width: 18px;
        height: 18px;
        transition: transform 0.2s ease-in;
        transform: rotate(-90deg);
    }
    .saperator.is-open .saperator-caret {
        transform: rotate(0deg);
    }
    .sidebar-subheader {
        padding: 4px 20px 6px;
        font-size: 11px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.8px;
        color: #b0bec5;
    }
    /* Children hang off a guide rail; the active child gets a dot on it. */
    .sub-item {
        display: none;
        margin: -2px 5px 8px 32px;
        padding-left: 6px;
        border-left: 2px solid rgba(156, 67, 55, 0.2);
    }
    .sidebar-link.selected ~ .sub-item {
        display: block;
        animation: sidebarReveal 0.18s ease-out;
    }
    .sub-item .sub-link {
        position: relative;
        padding-left: 14px;
        height: 40px;
        margin: 0 0 2px;
        font-size: 14px;
    }
    .sub-item .sub-link.selected {
        background: transparent;
        color: #9c4337;
        font-weight: 500;
    }
    .sub-item .sub-link.selected::before {
        content: "";
        position: absolute;
        left: -11px;
        top: 50%;
        width: 8px;
        height: 8px;
        margin-top: -4px;
        border-radius: 50%;
        background: #9c4337;
        box-shadow: 0 0 0 2px #ffffff;
    }
    .sub-item .sub-link.selected .sidebar-icon {
        color: #9c4337;
    }
    .sub-item .sub-link.selected .dd-icon {
        color: #9c4337;
        transform: rotate(-180deg);
    }
    .child-sub-item {
        display: none;
        margin-left: 14px;
        padding-left: 6px;
        border-left: 2px solid rgba(156, 67, 55, 0.2);
    }
    .sub-link.selected + .child-sub-item {
        display: block;
        animation: sidebarReveal 0.18s ease-out;
    }
    .child-sub-item .sub-link {
        padding-left: 14px;
    }
  `]
})

export class VerticalAppSidebarComponent implements OnInit, OnDestroy {
  public config: any = {};
  mobileQuery: MediaQueryList;

  private _mobileQueryListener: () => void;
  private subscriptions: Subscription[] = [];
  status = true;

  itemSelect: number[] = [];
  sections: SidebarSection[] = [];
  // Accordion: at most one section is open, and with none open the default
  // (Vouchers) opens again.
  private openSection: string | null = null;
  private defaultSection: string | null = null;
  parentIndex = 0;
  childIndex = 0;

  // User profile data
  currentUser: UserProfile | null = null;
  userDisplayName = 'User';
  userProfilePhotoUrl: string | SafeUrl | null = null;
  hasUserPhoto = false;
  private photoObjectUrl: string | null = null;

  // Branding data
  branding: OrganizationBranding | null = null;
  logoUrl = 'assets/images/logo.png';

  setClickedRow(i: number, j: number) {
    this.parentIndex = i;
    this.childIndex = j;
  }
  subclickEvent() {
    this.status = true;
  }
  scrollToTop() {
    document.querySelector('.page-wrapper')?.scroll({
      top: 0,
      left: 0
    });
  }

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    public menuItems: MenuItems,
    private authService: AuthService,
    private profileService: ProfileService,
    private brandingService: BrandingService,
    private router: Router,
    private sanitizer: DomSanitizer,
    // Bank Reconciliation and Research Grants are switched off (API routes commented out).
    // private reconciliationBadge: ReconciliationAlertBadgeService,
    // private grantBadge: GrantAlertBadgeService
  ) {
    this.mobileQuery = media.matchMedia('(min-width: 768px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    // tslint:disable-next-line: deprecation
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngOnInit(): void {
    // Privileges arrive after login from a separate request, so the menu
    // filtered on them must be rebuilt when they land -- built only once it
    // would show just the unrestricted links until a page refresh.
    this.subscriptions.push(
      this.authService.authState$
        .pipe(
          map(state => `${state.user?.role ?? ''}|${(state.privileges || []).map(p => p.name).join(',')}`),
          distinctUntilChanged()
        )
        .subscribe(() => this.buildSections())
    );

    // Keep the active page visible when it is reached from outside the
    // sidebar (deep link, redirect, in-page navigation).
    this.subscriptions.push(
      this.router.events
        .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
        .subscribe(event => this.openSectionForUrl(event.urlAfterRedirects))
    );

    this.loadUserProfile();
    this.loadBranding();
    // Open high-severity reconciliation and grant misuse alerts show as one
    // badge on the Compliance Assurance Console item.
    // this.reconciliationBadge.start();
    // this.grantBadge.start();

    // Subscribe to profile changes (name, email, etc.)
    this.subscriptions.push(
      this.profileService.profile$.subscribe(profile => {
        if (profile) {
          this.currentUser = profile;
          this.userDisplayName = `${profile.firstName} ${profile.lastName}`;
        }
      })
    );

    // Subscribe to shared photo URL changes
    this.subscriptions.push(
      this.profileService.profilePhotoUrl$.subscribe(url => {
        if (url) {
          this.userProfilePhotoUrl = this.sanitizer.bypassSecurityTrustUrl(url);
          this.hasUserPhoto = true;
        } else {
          this.userProfilePhotoUrl = null;
          this.hasUserPhoto = false;
        }
      })
    );

    // Subscribe to branding changes
    this.subscriptions.push(
      this.brandingService.branding$.subscribe(branding => {
        this.branding = branding;
        this.updateLogoUrl(branding);
      })
    );
  }

  private buildSections(): void {
    this.sections = this.menuItems.getSidebarSections();
    const named = this.sections.filter(section => section.name);
    const preferred = named.find(section => this.menuItems.isSectionOpenByDefault(section.name));
    this.defaultSection = (preferred || named[0])?.name ?? null;
    // Rebuilt when privileges land after login: keep the open section while
    // it still exists, otherwise fall back to the default.
    if (!this.sections.some(section => section.name === this.openSection)) {
      this.openSection = this.defaultSection;
    }
    this.openSectionForUrl(this.router.url);
  }

  isSectionOpen(name: string): boolean {
    return this.openSection === name;
  }

  /** Opening a section closes the others; closing the open one falls back to the default. */
  toggleSection(name: string): void {
    this.openSection = this.openSection === name ? this.defaultSection : name;
  }

  private openSectionForUrl(url: string): void {
    const path = url.split(/[?#]/)[0];
    // Longest matching state wins, so /dms/assets/transfers resolves to its
    // own link rather than the /dms/assets prefix.
    let bestSection: string | null = null;
    let bestLength = 0;
    for (const section of this.sections) {
      for (const item of section.items) {
        const state = '/' + item.state;
        const matches = path === state || path.startsWith(state + '/');
        if (item.state && matches && state.length > bestLength) {
          bestSection = section.name;
          bestLength = state.length;
        }
      }
    }
    if (bestSection) {
      this.openSection = bestSection;
    }
  }

  private loadUserProfile(): void {
    // Get basic user info from auth service immediately
    const user = this.authService.getCurrentUser();
    if (user) {
      this.userDisplayName = `${user.firstName} ${user.lastName}`;
    }

    // Load full profile from API
    this.profileService.getMyProfile().subscribe(
      profile => {
        this.currentUser = profile;
        this.userDisplayName = `${profile.firstName} ${profile.lastName}`;
        this.loadProfilePhoto(profile);
      },
      error => console.error('Failed to load profile:', error)
    );
  }

  private loadBranding(): void {
    this.brandingService.getBranding().subscribe(
      branding => {
        this.branding = branding;
        this.updateLogoUrl(branding);
      },
      error => console.error('Failed to load branding:', error)
    );
  }

  private loadProfilePhoto(profile: UserProfile): void {
    if (!profile?.id) { return; }
    this.profileService.getProfilePhotoBlobUrl(profile.id).subscribe(
      objectUrl => {
        if (this.photoObjectUrl) { URL.revokeObjectURL(this.photoObjectUrl); }
        this.photoObjectUrl = objectUrl;
        this.userProfilePhotoUrl = this.sanitizer.bypassSecurityTrustUrl(objectUrl);
        this.hasUserPhoto = true;
        this.profileService.setProfilePhotoUrl(objectUrl);
      },
      () => {
        this.hasUserPhoto = false;
        this.userProfilePhotoUrl = null;
        this.profileService.setProfilePhotoUrl(null);
      }
    );
  }

  private updateLogoUrl(branding: OrganizationBranding): void {
    if (branding?.logoPath) {
      this.logoUrl = `${environment.apiUrl}/branding/logo?t=${Date.now()}`;
    } else {
      this.logoUrl = 'assets/images/logo.png';
    }
  }

  goToProfile(): void {
    this.router.navigate(['/dms/profile']);
  }

  logout(): void {
    // this.authService.logout();
    this.authService.signOut(); // revoke on the server too
    this.router.navigate(['/auth/login']);
  }

  onImageError(event: Event): void {
    (event.target as HTMLImageElement).src = 'assets/images/users/profile.png';
  }

  onLogoError(event: Event): void {
    (event.target as HTMLImageElement).src = 'assets/images/logo.png';
  }

  ngOnDestroy(): void {
    // tslint:disable-next-line: deprecation
    this.mobileQuery.removeListener(this._mobileQueryListener);
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if (this.photoObjectUrl) { URL.revokeObjectURL(this.photoObjectUrl); }
  }
}
